// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2aHWO","label":"LabeledBox_label__2jil9"};